import React from 'react';
import { AuthProvider } from './auth';
import { ToastProvider } from './toast';
import { CompanyProvider } from './company';
import { ConfigurationProvider } from './configuration';

interface IAppProvider {
  children: React.ReactNode;
}

const AppProvider: React.FC<IAppProvider> = ({ children }) => (
  <AuthProvider>
    <ConfigurationProvider>
      <CompanyProvider>
        <ToastProvider>{children}</ToastProvider>
      </CompanyProvider>
    </ConfigurationProvider>
  </AuthProvider>
);

export default AppProvider;
